/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-key */
import { usePayAnInvoiceFormData } from "@/store/payAnInvoiceFormsStore";
import AppButton from "../buttons/AppButton";
import AppText from "../other/AppText";

import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

import { cn } from "@/lib/utils";
import { Textarea } from "../ui/textarea";
import { format, parseISO } from "date-fns";
import {
  CUSTOMER_TYPE_FOR_BILL_TO_ADDRESS,
  CUSTOMER_TYPE_FOR_SITE_ADDRESS,
  OTHERS_SELECT_OPTION_CODE,
} from "./constants";
import { getCurrencySymbol } from "./helpers";
import { Info24 } from "@/assets/Icons";

const formatDate = (date: string) => {
  const parseDate = parseISO(date);
  const formattedDate = format(parseDate, "MMM dd, yyyy");

  return formattedDate.replace(",", "");
};

const getReasons = (data: any): any => {
  const reasonsList: any = [];
  data.forEach((item: { fields: { key: any; title: any } }, index: number) => {
    if (index > 1) {
      reasonsList.push({
        id: item.fields.key,
        title: item.fields.title,
      });
    }
  });
  return reasonsList;
};

const getHeadingForMobile = (data: any, invoiceResponse: any, adress: any): any => {
  const invoiceStatementItem = invoiceResponse;
  const siteAdress = adress.find((item: any) => item.DOC_NO == invoiceStatementItem?.DOC_NO);
  const invoiceLineItem = invoiceStatementItem?.LINES?.item?.[0];
  const mobileViewRes: any = [];
  const heading: any = [];
  const values: any = [];
  data.forEach((item: { fields: { name: any }[] }, index: number) => {
    if (index == 0) {
      heading.push(item?.fields?.[1]?.name);
      heading.push(item?.fields?.[2]?.name);
    } else {
      heading.push(item?.fields?.[0]?.name);
    }
  });
  values.push(siteAdress.SITE_NAME);
  values.push(invoiceLineItem?.ALLOC_NMBR);
  values.push(formatDate(invoiceStatementItem?.DOC_DATE));
  values.push(formatDate(invoiceStatementItem?.BLINE_DATE));
  values.push(invoiceStatementItem?.DOC_NO);
  values.push(`${getCurrencySymbol(invoiceStatementItem)} ${invoiceStatementItem?.BALANCE}`);

  heading.forEach((item: any, index: number) => {
    if (index < 6) {
      mobileViewRes.push({
        id: index,
        heading: heading[index],
        values: values[index],
      });
    } else {
      mobileViewRes.push({
        id: index,
        heading: heading[index],
        values: "",
      });
    }
  });
  return mobileViewRes;
};

const getHeadingForWeb = (data: any, invoiceResponse: any, adress: any): any => {
  const invoiceStatementItem = invoiceResponse;
  const siteAdress = adress.find((item: any) => item.DOC_NO == invoiceStatementItem?.DOC_NO);

  const mobileViewRes: any = [];
  const heading: any = [];
  const values: any = [];
  data.forEach((item: { fields: { name: any }[] }, index: number) => {
    if (index == 0) {
      heading.push(item?.fields?.[1]?.name);
      heading.push(item?.fields?.[2]?.name);
    } else {
      heading.push(item?.fields?.[0]?.name);
    }
  });

  values.push(siteAdress?.SITE_NAME);
  values.push(formatDate(invoiceStatementItem?.DOC_DATE));
  values.push(formatDate(invoiceStatementItem?.BLINE_DATE));
  values.push(invoiceStatementItem?.DOC_NO);
  values.push(`${getCurrencySymbol(invoiceStatementItem)} ${invoiceStatementItem?.BALANCE}`);

  values.forEach((item: any, index: string | number) => {
    mobileViewRes.push({
      id: index,
      heading: heading[index],
      values: values[index],
    });
  });
  return mobileViewRes;
};

const getMultiplePayments = (invoices: any) => {
  const balanceAmount: any = {};
  invoices.map((invoice: any) => {
    balanceAmount[invoice.DOC_NO] = invoice.BALANCE;
  });

  return balanceAmount;
};

const getMultipleValues = (invoice: any) => {
  const selectValues: any = {};
  invoice.map((invoice: any) => {
    selectValues[invoice.DOC_NO] = "";
  });
  return selectValues;
};

const getMultipleSelectDisable = (invoice: any) => {
  const selectValues: any = {};
  invoice.map((invoice: any) => {
    selectValues[invoice.DOC_NO] = true;
  });
  return selectValues;
};

const sumOfPayment = (multiplePayments: any) => {
  const paymentArray = Object.values(multiplePayments);
  let sum = 0;
  paymentArray.forEach((item) => {
    sum += Number(item);
  });

  return Number.parseFloat(sum.toString()).toFixed(2).toString();
};

const checkNextEnable = (allInvoice: any, paymentAmount: any, selectedOption: any, reason: any, balanceValues: any) => {
  const value = allInvoice.every((invoice: number) => {
    const amountPayment = paymentAmount[invoice] ? Number(paymentAmount[invoice]) : undefined;
    const amountDue = Number(balanceValues[invoice]);

    if (amountDue < 0) {
      return false;
    }
    if (invoice === undefined) {
      return false;
    }

    if (amountPayment === undefined || amountPayment === 0) {
      return false;
    }

    if (amountPayment !== amountDue) {
      if (selectedOption[invoice] === OTHERS_SELECT_OPTION_CODE.othersReasonCode) {
        return reason[invoice] !== "";
      }
      return selectedOption[invoice] !== "";
    }

    return true;
  });
  return value;
};

const changeState = (setState: (state: any) => void, key: number, value: any) => {
  setState((prev: any) => ({
    ...prev,
    [key]: value,
  }));
};

const getInvoiceOpenItemsPayload = (multipleInvoiceItems: any, updatedStatementLines: any) => {
  multipleInvoiceItems.forEach(async (invoice: any) => {
    const itemsData: any = [];
    invoice.LINES.item.forEach((lineItem: any) => {
      const itemData = {
        BUKRS: lineItem.COMP_CODE.toString(),
        BELNR: lineItem.DOC_NO.toString(),
        GJAHR: lineItem.FISC_YEAR.toString(),
      };
      itemsData.push(itemData);
    });
    const today = new Date();
    const formattedDate = format(today, "yyyyMMdd");
    const payloadInvoice = {
      IT_DOC_NO: { item: itemsData },
      KEYDATE: formattedDate,
      KUNNR: invoice.CUSTOMER,
      VKORG: invoice.LINES.item[0].COMP_CODE.toString(),
    };

    const headers = {
      guestpaymentkey: `${process.env.NEXT_PUBLIC_API_KEY}`,
    };

    const invoiceOpenItems = await fetch("/api/invoice-open-items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payloadInvoice),
    });

    const validateRespones = await invoiceOpenItems.json();
    const adress = updatedStatementLines.find((item: any) => item.DOC_NO == invoice.DOC_NO);
    invoice["accountName"] = adress.ACCOUNT_NAME;
    invoice["siteAdress"] = adress.SITE_NAME;
    invoice["billingAdress"] = adress.BILL_TO_ADDRESS;
    invoice["openItems"] = [validateRespones?.["ZFI_CUSTOMER_OPEN_INVOICES_ITM.Response"]?.RESULT?.item];
  });

  return multipleInvoiceItems;
};

const FormRequestPayAnInvoiceStep2 = ({ formData, label, formTab }: { formData: any; label: any; formTab: any }) => {
  const invoiceResponse = usePayAnInvoiceFormData((state) => state.customerInvoiceResponse);
  const showMsgForMissingInvoices = usePayAnInvoiceFormData((state) => state.showMsgForMissingInvoices);
  const invoiceStatementItem = invoiceResponse?.STATEMENT_LINES?.item?.[0];
  const multipleInvoiceItems = invoiceResponse?.STATEMENT_LINES?.item;

  const formFieldoptions = formData[6].fields[1].fieldOptions;

  const setStepAndFormDataSecondTab = usePayAnInvoiceFormData((state) => state.setStepAndFormDataSecondTab);
  const setStep = usePayAnInvoiceFormData((state) => state.setStep);
  const formDataSecondTab = usePayAnInvoiceFormData((state) => state.formDataSecondTab);
  const resetFormDataSecondTab = usePayAnInvoiceFormData((state) => state.resetFormDataSecondTab);
  const setSelectedInvoicesResponse = usePayAnInvoiceFormData((state) => state.setSelectedInvoicesResponse);

  const [paymentAmount, setPaymentAmount] = useState<any>(
    formDataSecondTab.Payment_amount ?? getMultiplePayments(multipleInvoiceItems)
  );
  const [selectedOption, setSelectedOption] = useState<any>(
    formDataSecondTab.Selected_option ?? getMultipleValues(multipleInvoiceItems)
  );
  const [isDisable, setIsDisable] = useState<any>(
    formDataSecondTab.isDisable ?? getMultipleSelectDisable(multipleInvoiceItems)
  );
  const [reason, setReason] = useState<any>(formDataSecondTab.enteredReason ?? getMultipleValues(multipleInvoiceItems));
  const [adressLines, setAdresss] = useState();
  const [selectedReason, setSelectedReason] = useState<any>(
    formDataSecondTab.Reason ?? getMultipleValues(multipleInvoiceItems)
  );

  const balanceValues: any = {};
  const allInvoice: any = [];
  multipleInvoiceItems.forEach((item: any) => {
    balanceValues[item.DOC_NO] = item.BALANCE;
    allInvoice.push(item.DOC_NO);
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const invoicePayloadResponses = invoiceResponse;
    const statementLineItems: any = invoicePayloadResponses?.STATEMENT_LINES?.item || [];

    const updatedStatementLines = statementLineItems.map((lineItem: any, index: any) => {
      // get bill to and site name address
      const billToPartner = invoicePayloadResponses?.ORDER_PARTNERS?.item?.find(
        (orderPartner: any) =>
          orderPartner.CUSTOMER === lineItem?.BILL_TO_PARTY &&
          orderPartner.PARTN_ROLE === CUSTOMER_TYPE_FOR_BILL_TO_ADDRESS
      );

      const billToPartnerAddress = invoicePayloadResponses?.ORDER_ADDRESSES?.item?.find(
        (partnerAddress: any) => partnerAddress.ADDRESS === billToPartner?.ADDRESS
      );

      const sitePartner = invoicePayloadResponses?.ORDER_PARTNERS?.item?.find(
        (orderPartner: any) =>
          orderPartner.SD_DOC === lineItem.DOC_NO && orderPartner.PARTN_ROLE === CUSTOMER_TYPE_FOR_SITE_ADDRESS
      );

      const sitePartnerAddress = invoicePayloadResponses?.ORDER_ADDRESSES?.item?.find(
        (partnerAddress: any) => partnerAddress.ADDRESS === sitePartner?.ADDRESS
      );
      const siteNameFormatted: string = [
        sitePartnerAddress?.STREET,
        sitePartnerAddress?.CITY,
        sitePartnerAddress?.REGION,
      ]
        .filter(Boolean)
        .join(", ");

      const billToAdress: string = [
        billToPartnerAddress?.STREET,
        billToPartnerAddress?.CITY,
        billToPartnerAddress?.REGION,
      ]
        .filter(Boolean)
        .join(", ");

      return {
        ...lineItem,
        UNIQUE_ID: `${lineItem.DOC_NO}-${lineItem.CUSTOMER}-${index}`,
        SITE_NAME: siteNameFormatted,
        ACCOUNT_NAME: billToPartnerAddress?.NAME,
        BILL_TO_ADDRESS: billToAdress,
        DOC_DATE: lineItem.DOC_DATE,
        CLEAR_DATE: lineItem.CLEAR_DATE,
        BLINE_DATE: lineItem.BLINE_DATE,
        DELIVERY_DATE: lineItem.DELIVERY_DATE,
      };
    });

    const openItems = getInvoiceOpenItemsPayload(multipleInvoiceItems, updatedStatementLines);
    setSelectedInvoicesResponse(openItems);

    setAdresss(updatedStatementLines);
  }, [invoiceResponse, multipleInvoiceItems, setSelectedInvoicesResponse]);

  const onHanldeSubmit = async () => {
    setStepAndFormDataSecondTab(3, {
      Amount_due: sumOfPayment(paymentAmount),
      Payment_amount: paymentAmount,
      Selected_option: selectedOption,
      Reason: selectedOption === OTHERS_SELECT_OPTION_CODE.othersReasonCode ? reason : selectedReason,
      Currency: invoiceStatementItem?.CURRENCY,
      isDisable: isDisable,
      enteredReason: reason,
    });
  };

  const onHandleDropdown = (item: string, invoice: number) => {
    const selectedOption = getReasons(formFieldoptions).filter((select: { id: string; title: string }) => {
      if (select.id === item) {
        return select.title;
      }
    });
    setSelectedReason((prev: any) => ({
      ...prev,
      [invoice]: selectedOption[0]?.title ?? "",
    }));
    setSelectedOption((prev: any) => ({
      ...prev,
      [invoice]: item,
    }));
  };

  const onHandleChange = (event: string, invoice: number, balance: string) => {
    const decimalRegex = /^[0-9]*\.?[0-9]*$/; // Regex to match decimal numbers
    let input = event;

    if (!decimalRegex.test(input)) {
      return;
    }

    if (!/^\d*\.?\d{0,2}$/.test(input)) {
      return;
    }

    if (isNaN(Number(input))) {
      input = "";
      changeState(setPaymentAmount, invoice, "");
    }
    if (Number(input) == Number(balance)) {
      changeState(setSelectedOption, invoice, "");
      changeState(setReason, invoice, "");
      changeState(setSelectedReason, invoice, "");
      changeState(setIsDisable, invoice, true);
      changeState(setPaymentAmount, invoice, input);
    } else if (Number(input) > Number(balance)) {
      changeState(setIsDisable, invoice, true);
      changeState(setPaymentAmount, invoice, input);
      changeState(setSelectedOption, invoice, "");
      changeState(setReason, invoice, "");
      changeState(setSelectedReason, invoice, "");
    } else {
      if (input == "") {
        changeState(setPaymentAmount, invoice, "");
      } else {
        changeState(setIsDisable, invoice, false);
        changeState(setPaymentAmount, invoice, input);
      }
    }
  };

  const onHandleBlur = (invoice: number, balance: string) => {
    if (Number(paymentAmount[invoice]) > Number(balance)) {
      changeState(setIsDisable, invoice, true);
      changeState(setPaymentAmount, invoice, Number.parseFloat(balance).toFixed(2));
      changeState(setSelectedOption, invoice, "");
      changeState(setReason, invoice, "");
      changeState(setSelectedReason, invoice, "");
      return;
    }
    if (paymentAmount[invoice] == "") {
      changeState(setPaymentAmount, invoice, "0.00");
    } else {
      changeState(setPaymentAmount, invoice, Number.parseFloat(paymentAmount[invoice]).toFixed(2));
    }
  };

  const onHandleTextArea = (item: any, invoice: number) => {
    changeState(setReason, invoice, item.target.value);
  };

  return (
    <div className="lg:col-span-10 lg:col-start-2 col-span-4 px-6 pt-12 bg-white">
      <AppText type="SUB_HEADING_MEDIUM" className="mb-[28px]">
        {label}
      </AppText>

      <div className="lg:block md:hidden hidden">
        <div className="lg:grid-cols-1 grid">
          <div className="lg:grid-cols-7 grid gap-4 bg-[#E6EFF8] border-b-[1px] border-b-[#CDD2D5] lg:px-[20px] lg:py-[10px] px-[10px] py-[5px] ">
            {formData.map((item: any, index: number) => (
              <div key={item} className={`lg:text-start lg:items-center  flex  `}>
                {index == 0 ? (
                  <div className=" overflow-clip flex flex-col w-full">
                    <AppText type="BUTTON_SMALL" className="font-[700]">
                      {item.fields[0].name}
                    </AppText>
                  </div>
                ) : (
                  <AppText type="BUTTON_SMALL" className="font-[700]">
                    {item.fields[0].name}
                  </AppText>
                )}
              </div>
            ))}
          </div>
          {multipleInvoiceItems.map((invoice: any) => {
            return (
              <div className=" lg:grid-cols-7  grid gap-4 bg-[#E6EFF8] border-b-[1px] border-b-[#CDD2D5] lg:px-[20px] lg:py-[10px]  ">
                {adressLines &&
                  getHeadingForWeb(formData, invoice, adressLines).map((item: any, index: number) => (
                    <div
                      key={item}
                      className={`lg:text-start lg:justify-start  lg:items-center flex   overflow-clip w-full
                `}
                    >
                      {index == 0 ? (
                        <div className=" overflow-clip flex flex-col w-full">
                          <AppText
                            type="BODY_SMALL"
                            className=" truncate font-[600] cursor-pointer"
                            title={item.values}
                          >
                            {item.values}
                          </AppText>
                          <AppText type="BODY_SMALL" className="truncate">
                            {invoice?.LINES?.item?.[0]?.ALLOC_NMBR}
                          </AppText>
                        </div>
                      ) : (
                        <AppText type="BODY_SMALL" className="truncate">
                          {item.values}
                        </AppText>
                      )}
                    </div>
                  ))}
                <div className="lg:text-start lg:items-center lg:justify-start flex justify-end">
                  <input
                    className="lg:h-[40px] h-[30px] w-full px-2 border border-black border-1 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    type="text"
                    id="myTextField"
                    value={paymentAmount[invoice.DOC_NO]}
                    disabled={Number(paymentAmount[invoice.DOC_NO]) < 0}
                    onChange={(event) => {
                      onHandleChange(event.target.value, invoice.DOC_NO, invoice.BALANCE);
                    }}
                    min={0}
                    onBlur={() => {
                      onHandleBlur(invoice.DOC_NO, invoice.BALANCE);
                    }}
                  />
                </div>
                <div className=" lg:text-start lg:items-start lg:justify-center lg:flex-col flex flex-wrap items-start justify-end">
                  <div className="lg:flex-col lg:justify-start lg:items-start flex flex-col items-end justify-end">
                    <Select
                      disabled={isDisable[invoice.DOC_NO]}
                      onValueChange={(item) => {
                        onHandleDropdown(item, invoice.DOC_NO);
                      }}
                      value={selectedOption[invoice.DOC_NO]}
                    >
                      <SelectTrigger
                        className={cn(
                          "!mt-0 border-[#898A8D] placeholder:text-[#64748b] rounded-[5px] w-[100px] lg:h-[40px] h-[24px]"
                        )}
                        title="label"
                      >
                        <SelectValue
                          placeholder={`${formFieldoptions?.[0]?.fields.title}`}
                          className="placeholder:text-[#64748b]"
                        />
                      </SelectTrigger>

                      <SelectContent
                        style={{
                          position: "relative",
                          zIndex: 1300,
                          top: "auto",
                          maxHeight: "250px",
                          overflowY: "auto",
                          width: "300px",
                        }}
                      >
                        {getReasons(formFieldoptions).map((dur: any) => (
                          <SelectItem aria-label={dur.title} key={dur.id} value={dur.id}>
                            {dur.title}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    {selectedOption[invoice.DOC_NO] == OTHERS_SELECT_OPTION_CODE.othersReasonCode && (
                      // &&!isDisable
                      <Textarea
                        placeholder={`${formFieldoptions?.[1]?.fields.title}`}
                        id="text-area"
                        className="mt-1"
                        value={reason[invoice.DOC_NO]}
                        onChange={(item) => {
                          onHandleTextArea(item, invoice.DOC_NO);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="lg:hidden block">
        {multipleInvoiceItems.map((invoice: any) => {
          return (
            <div className="bg-[#E6EFF8] flex flex-col flex-1 px-4 py-4 border-b-[1px] border-b-[#CDD2D5]">
              {adressLines &&
                getHeadingForMobile(formData, invoice, adressLines).map((ele: any, index: any) => {
                  return (
                    <div className="flex-2 flex flex-row w-full mb-1">
                      <div className=" flex flex-wrap flex-1">
                        <AppText type="BODY_SMALL" className="truncate font-[600]">
                          {ele.heading}
                        </AppText>
                      </div>
                      <div
                        className="text-ellipsis flex flex-wrap justify-end flex-1 overflow-hidden cursor-pointer"
                        title={`${ele.values}`}
                      >
                        {index <= 5 && (
                          <AppText type="BODY_SMALL" className="f truncate">
                            {ele.values}
                          </AppText>
                        )}
                        {index == 6 && (
                          <input
                            type="text"
                            id="myTextField"
                            disabled={Number(paymentAmount[invoice.DOC_NO]) < 0}
                            value={paymentAmount[invoice.DOC_NO]}
                            className="w-[100px]  border-[1px] p-1 border-black [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            onChange={(event) => {
                              onHandleChange(event.target.value, invoice.DOC_NO, invoice.BALANCE);
                            }}
                            min={0}
                            onBlur={() => {
                              onHandleBlur(invoice.DOC_NO, invoice.BALANCE);
                            }}
                          />
                        )}
                        {index == 7 && (
                          <div className=" flex-col">
                            <div className="flex justify-end flex-1 space-y-0">
                              <Select
                                disabled={isDisable[invoice.DOC_NO]}
                                onValueChange={(item) => {
                                  onHandleDropdown(item, invoice.DOC_NO);
                                }}
                                value={selectedOption[invoice.DOC_NO]}
                              >
                                <SelectTrigger
                                  className={cn(
                                    "!mt-0 border-[#898A8D] placeholder:text-[#64748b] rounded-[5px] w-[100px] lg:h-[40px] h-[24px]"
                                  )}
                                  title="label"
                                >
                                  <SelectValue
                                    placeholder={`${formFieldoptions?.[0]?.fields?.title}`}
                                    className="placeholder:text-[#64748b]"
                                  />
                                </SelectTrigger>

                                <SelectContent
                                  style={{
                                    position: "relative",
                                    zIndex: 1300,
                                    top: "auto",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "180px",
                                  }}
                                >
                                  {getReasons(formFieldoptions).map((dur: any) => (
                                    <SelectItem aria-label={dur.title} key={dur.id} value={dur.id}>
                                      {dur.title}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </div>
                            {selectedOption[invoice.DOC_NO] == OTHERS_SELECT_OPTION_CODE.othersReasonCode && (
                              <div>
                                <Textarea
                                  placeholder={`${formFieldoptions?.[1]?.fields?.title}`}
                                  className="mt-1"
                                  id="text-area"
                                  value={reason[invoice.DOC_NO]}
                                  onChange={(item) => {
                                    onHandleTextArea(item, invoice.DOC_NO);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        })}
      </div>

      <div className=" flex flex-col justify-end mt-4">
        <div className="flex justify-end">
          <AppText type="TITLE_X_SMALL" className="font-[600] normal-case">
            {formTab?.groups?.[0]?.description} {getCurrencySymbol(invoiceStatementItem)}
            {sumOfPayment(paymentAmount)}
          </AppText>
        </div>
        {showMsgForMissingInvoices && (
          <div className=" flex justify-end">
            <div className="bg-[#E4E0DA] flex p-3 rounded-md">
              <Info24 />
              <AppText type="BODY_SMALL_EMPHASIS">{formTab?.groups?.[0]?.subDescription}</AppText>
            </div>
          </div>
        )}
      </div>

      <div className="mt-24 mb-[78px]">
        <button id="targetSubmit" className="hidden" aria-label="submit target" type="submit"></button>
        <div className="flex flex-row flex-wrap justify-end gap-4 bg-white">
          <AppButton
            intent="secondary"
            label={formTab.ctaBack}
            type="button"
            className="px-10"
            onMouseDown={() => {
              setStep(1);
              resetFormDataSecondTab();
            }}
          />
          <AppButton
            disabled={!checkNextEnable(allInvoice, paymentAmount, selectedOption, reason, balanceValues)}
            intent="primary"
            label={formTab.ctaNext}
            type="submit"
            className="px-10"
            onMouseDown={onHanldeSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default FormRequestPayAnInvoiceStep2;
